import { useEffect } from "react";
import { useSelector } from "react-redux";
import { identifyUser } from "utils/exponea";
import * as userSelectors from "redux/user/selectors";

export const useBloomreachInit = () => {
  const userData = useSelector(userSelectors.all) || "";

  useEffect(() => {
    if (exponea) {
      if (userData.id) {
        identifyUser(
          // eslint-disable-next-line camelcase
          { customer_id: userData.id },
          {
            email: userData.login,
            ...(userData.name && { firstName: userData.name }),
          },
        );
      }

      if ("Notification" in window && Notification?.permission === "default") {
        window.addEventListener(
          "click",
          () => {
            if (exponea.notifications.subscribe) {
              exponea.notifications.subscribe(() => {
                // eslint-disable-next-line no-console
                console.log("✅ Уведомления разрешены");
              });
            }
          },
          { once: true },
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.id]);
};
